import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = {
  class: "scroll-container"
};
const _hoisted_2 = {
  class: "flex align-middle"
};
const _hoisted_3 = {
  class: "text-base font-medium"
};
const _hoisted_4 = {
  key: 1,
  class: "bg-green-100 text-green-dark text-xs font-medium mx-2 px-2 rounded-md dark:text-green-light border border-green-light"
};
const _hoisted_5 = {
  class: "cursor-pointer flex justify-end align-middle items-center mr-4"
};
const _hoisted_6 = {
  key: 0,
  class: "mt-4 flex flex-col align-center justify-center at-loading-adv-report"
};
const _hoisted_7 = {
  key: 1
};
const _hoisted_8 = {
  class: "w-full"
};
const _hoisted_9 = {
  class: "cursor-pointer flex justify-end align-middle items-center mr-4"
};
const _hoisted_10 = {
  class: "rounded-md"
};
const _hoisted_11 = {
  class: "w-full"
};
const _hoisted_12 = {
  class: "scroll-container"
};
const _hoisted_13 = {
  key: 0
};
const _hoisted_14 = {
  key: 1
};
const _hoisted_15 = {
  class: "cursor-pointer flex justify-end align-middle items-center mr-4"
};
const _hoisted_16 = {
  key: 0,
  class: "mt-4 flex flex-col align-center justify-center at-loading-custom-report"
};
const _hoisted_17 = {
  key: 1,
  class: "at-custom-reports"
};
const _hoisted_18 = {
  class: "rounded-md at-nav-item-contents"
};
const _hoisted_19 = {
  class: "report-item"
};
const _hoisted_20 = {
  class: "cursor-pointer flex justify-end items-center align-middle mr-4"
};
const _hoisted_21 = {
  key: 0,
  class: "mt-4 flex flex-col align-center justify-center at-loading-shared-report"
};
const _hoisted_22 = {
  key: 1
};
const _hoisted_23 = {
  key: 0
};
const _hoisted_24 = {
  key: 1
};
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LeftNavBar from './LeftNavBar.vue';
import InsightsHome from '@/modules/insights/InsightsHome.vue';
import ArrowDownSvg from './ArrowDownSvg.vue';
import ArrowUpSvg from './ArrowUpSvg.vue';
import NavStandardDashboard from './NavStandardDashboard.vue';
import { reactive, onMounted, ref, computed } from 'vue';
import Loader from '@/components/Loader.vue';
import { useEmbeddedReportStore } from './useEmbeddedReportStore.js';
import { useInsightsDashboardStore } from '@/modules/insights/useInsightsDashboardStore';
import RouterService from '@/services/RouteService';
import SplashPage from '@/modules/reports/SubscriptionUpgrade/SplashPage.vue';
import EventTracker from '../../../services/eventTracker';
export default {
  __name: 'Dashboard',
  props: {
    alerts: {
      type: Object,
      required: false
    },
    state: {
      type: Object,
      required: true
    },
    stateParams: {
      type: Object,
      required: true
    },
    userService: {
      type: Object,
      required: false
    },
    tracking: {
      type: Object,
      required: false
    },
    onboardService: {
      type: Object,
      required: false
    }
  },
  setup(__props) {
    const props = __props;
    const navStandardDashboard = ref(null);
    const insightHome = ref(null);
    const reportState = reactive({
      loadingDashboardTitle: false,
      showBetaTag: false,
      loading: false,
      reportOptions: [],
      dashboardId: undefined,
      dashboardProvider: 'luzmo',
      // 'luzmo' | 'metabase'
      luzmoDashboardId: undefined,
      embeddedReportKeys: undefined,
      upgradeToProDashboardId: undefined,
      reportAction: '',
      me: {},
      canUseEditor: '',
      editMode: undefined,
      drawer: true,
      openDrawer: false,
      standardReport: false,
      embeddedReport: false,
      customMetabaseReports: true,
      showCustomMetabaseReportsSection: false,
      customReports: false,
      leftNavBarOptions: [],
      isOnboardMessage: false,
      openSplashPage: false,
      proBadgeColor: '#f89406',
      betaBadgeColor: 'success',
      redirectToUpgradeDialog: false,
      showSplashPage: computed(() => {
        return !reportState.me.features.reportsAdvanced;
      })
    });
    const routeService = new RouterService(props);
    const embeddedReportStore = useEmbeddedReportStore();
    embeddedReportStore.alerts = props.alerts;
    const insightsDashboardStore = useInsightsDashboardStore();
    onMounted(async () => {
      if (props.stateParams.openDialog) {
        reportState.redirectToUpgradeDialog = props.stateParams.openDialog;
        reportState.openSplashPage = true;
        navStandardDashboard.value.style.display = 'none';
        insightHome.value.style.display = 'none';
        reportState.standardReport = false;
      }
      reportState.loadingDashboardTitle = true;
      reportState.standardReport = true;
      if (!reportState.standardReport) {
        insightHome.value.style.height = '100%';
      }
      checkOnBoardingMessageHeader();
      reportState.me = await props.userService.me();
      // await embeddedReportStore.listDashboard();
      await insightsDashboardStore.list('advanced');
      const customReports = await insightsDashboardStore.list('custom');
      reportState.showCustomMetabaseReportsSection = customReports.length > 0;
      if (!reportState.showCustomMetabaseReportsSection) {
        reportState.customMetabaseReports = false;
      }
      reportState.loadingDashboardTitle = false;
      reportState.dashboardId = embeddedReportStore.getDefaultDashboardId();
      reportState.embeddedReportKeys = embeddedReportStore.keys;
      reportState.leftNavBarOptions.push(...insightsDashboardStore.advancedReportGroup(), ...insightsDashboardStore.customReportGroup(), ...embeddedReportStore.customReportGroups(), ...embeddedReportStore.sharedReportGroups());
      reportState.canUseEditor = embeddedReportStore.keys?.canUseEditor;
      await openDeepLinkedReport();
    });

    /**
     * Opens the report named by the ?report param (a dashboard tag or id), the same
     * way the Overview page deep links by tag. Falls back to Standard Reports when
     * the value doesn't match a report this user can see.
     */
    const openDeepLinkedReport = async () => {
      const requested = props.stateParams?.report;
      if (!requested) {
        return;
      }
      const option = insightsDashboardStore.findByTagOrId(requested);
      if (!option) {
        console.warn(`[Reports] No advanced or custom report for "${requested}"`);
        return;
      }
      if (option.advancedReport) {
        reportState.advancedReports = true;
      } else if (option.embeddedMetabaseCustomReport) {
        reportState.customMetabaseReports = true;
      }
      embeddedReportStore.setHighlightedItem(option.id);
      await openDashboard(option, false);
    };

    /**
     * Reflects the open report in the URL so it can be copied and shared. Prefers
     * the tag over the id for a readable link.
     */
    const syncUrlWithReport = option => {
      if (!props.state?.go || props.state.current?.name !== 'reports.dashboard') {
        return;
      }
      const nextReport = option?.tag || option?.dashboardId || option?.id || null;
      const currentReport = props.stateParams?.report || null;
      if (nextReport === currentReport) {
        return;
      }
      props.state.go('reports.dashboard', {
        report: nextReport
      }, {
        notify: false,
        reload: false
      });
    };
    const editDashboard = id => {
      trackEvent('Dashboard', 'Edited', id);
      reportState.toggle = false;
      reportState.dashboardId = id;
      reportState.editMode = embeddedReportStore.keys.editMode;
      reportState.standardReport = false;
      reportState.embeddedReport = true;
    };
    const deleteDashboard = async id => {
      reportState.toggle = false;
      reportState.dashboardId = id;
      reportState.standardReport = false;
    };
    const openDashboard = async (option, canUseEditor = false) => {
      trackEvent('Dashboard', 'Opened', option.id);
      reportState.me = await props.userService.me();
      reportState.toggle = false;
      if (option && option.advancedReport && reportState.me.features?.upgradeShortTermReport && reportState.showSplashPage) {
        reportState.openSplashPage = true;
        reportState.standardReport = false;
        reportState.advancedReports = true;
        reportState.upgradeToProDashboardId = option.id;
        insightHome.value.style.display = 'none';
      } else {
        if (option.provider === 'metabase') {
          reportState.dashboardProvider = 'metabase';
          reportState.dashboardId = option.dashboardId || option.id;
          reportState.luzmoDashboardId = option.luzmoDashboardId || '';
        } else if (!reportState.me.features?.luzmoDead) {
          reportState.dashboardProvider = 'luzmo';
          reportState.dashboardId = option.id;
          reportState.luzmoDashboardId = option.id;
        }

        // Only Metabase reports can be resolved from a deep link, so a Luzmo report
        // clears the param rather than leaving an unopenable one in the URL.
        syncUrlWithReport(option.provider === 'metabase' ? option : null);
        reportState.upgradeToProDashboardId = undefined;
        insightHome.value.style.display = 'block';
        reportState.openSplashPage = false;
        if (canUseEditor) {
          reportState.editMode = 'editFull';
        } else {
          reportState.editMode = 'view';
        }
        reportState.standardReport = false;
        reportState.embeddedReport = true;
      }
    };
    const createDashboard = async () => {
      reportState.toggle = false;
      if (reportState.saving) {
        return;
      }
      reportState.saving = true;
      const response = await embeddedReportStore.createDashboard();
      reportState.standardReport = false;
      const customReportOptions = {
        dateRangeOptions: false,
        embedded: true,
        embeddedCustomReport: true,
        id: response.id,
        isOwner: response.isOwner,
        isVariant: response.isVariant,
        canUseEditor: embeddedReportStore.keys.canUseEditor,
        label: response.name,
        name: response.name,
        reportType: response.id,
        showReport: true,
        tooltipData: 'My Custom Report'
      };
      embeddedReportStore.customReportList.push(customReportOptions);
      if (embeddedReportStore.keys.canUseEditor) {
        openDashboard(response, true);
      } else {
        openDashboard(response, false);
      }
      trackEvent('Dashboard', 'Created', response.id);
      embeddedReportStore.setHighlightedItem(response.id);
      reportState.saving = false;
    };
    const standardReport = () => {
      reportState.toggle = false;
      reportState.embeddedReport = false;
      reportState.standardReport = true;
      reportState.openSplashPage = false;
      trackEvent('Standard Dashboard', 'Opened', undefined);
      embeddedReportStore.setHighlightedItem(undefined);
      syncUrlWithReport(null);
    };
    const toggleDrawer = () => {
      reportState.openDrawer = !reportState.openDrawer;
    };
    const copyDashboard = async dashboardId => {
      const response = await embeddedReportStore.copyDashboard(dashboardId);
      const copiedAdvancedDashboard = {
        dateRangeOptions: false,
        embedded: true,
        embeddedCustomReport: true,
        id: response.id,
        isAdvanced: response.isAdvanced,
        isCustom: response.isCustom,
        ownerId: response.owner_id,
        isOwner: response.isOwner,
        isVariant: response.isVariant,
        isShared: response.isShared,
        label: response.name,
        name: response.name,
        reportType: response.id,
        showReport: true,
        tag: response.tag
      };
      embeddedReportStore.customReportList.push(copiedAdvancedDashboard);
      openDashboard(response.id, true);
      trackEvent('Dashboard', 'Copied', response.id);
      embeddedReportStore.setHighlightedItem(response.id);
    };
    const checkOnBoardingMessageHeader = () => {
      props.onboardService.message().then(res => {
        if (res.summary) {
          reportState.isOnboardMessage = true;
        }
      });
    };
    const toggleAdvancedReports = () => {
      trackEvent('Advanced Dashboard', 'Clicked', undefined);
      reportState.advancedReports = !reportState.advancedReports;
    };
    const toggleCustomMetabaseReports = () => {
      trackEvent('Custom Dashboard', 'Clicked', undefined);
      reportState.customMetabaseReports = !reportState.customMetabaseReports;
    };
    const closeSplashPage = async value => {
      reportState.standardReport = false;
      reportState.me = await props.userService.me();
      reportState.embeddedReport = true;
      reportState.openSplashPage = false;
      if (me.features.reportsAdvanced || me.company.products.trial) {
        navStandardDashboard.value.style.display = 'none';
        insightHome.value.style.display = 'block';
      }
      props.userService.reload();
      props.state.go('reports.dashboard');
      EventTracker.trackEvent(props.tracking, 'Closed', 'Upgrade Splash Page');
    };
    const trackEvent = (category, action, dashboardId) => {
      EventTracker.trackEvent(props.tracking, category, action, {
        dashboardId: dashboardId ? dashboardId : undefined,
        Dashboard: dashboardId ? embeddedReportStore.getDashboardLabelAndNameByDashboardId(dashboardId)?.name : undefined
      });
    };
    return (_ctx, _cache) => {
      const _component_v_row = _resolveComponent("v-row");
      const _component_v_list_item = _resolveComponent("v-list-item");
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_list_item_title = _resolveComponent("v-list-item-title");
      const _component_v_badge = _resolveComponent("v-badge");
      const _component_v_progress_circular = _resolveComponent("v-progress-circular");
      const _component_v_list_item_content = _resolveComponent("v-list-item-content");
      const _component_v_list = _resolveComponent("v-list");
      const _component_v_alert = _resolveComponent("v-alert");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer");
      const _component_v_main = _resolveComponent("v-main");
      const _component_v_layout = _resolveComponent("v-layout");
      const _component_v_card = _resolveComponent("v-card");
      return reportState.loading ? (_openBlock(), _createBlock(Loader, {
        key: 0,
        what: 'Reports Dashboard',
        class: "mt-32"
      })) : (_openBlock(), _createBlock(_component_v_card, {
        key: 1
      }, {
        default: _withCtx(() => [_createVNode(_component_v_layout, null, {
          default: _withCtx(() => [_createVNode(_component_v_navigation_drawer, {
            modelValue: reportState.drawer,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => reportState.drawer = $event),
            rail: reportState.openDrawer,
            permanent: "",
            onClick: _cache[10] || (_cache[10] = $event => reportState.openDrawer = false),
            width: 380,
            class: _normalizeClass(["at-navigation-drawer", [reportState.isOnboardMessage || reportState.me?.impersonation ? 'mt-10' : '']])
          }, {
            default: _withCtx(() => [_createVNode(_component_v_list_item, {
              justify: "space-between",
              class: "mt-24 p-0",
              nav: ""
            }, {
              append: _withCtx(() => [_createVNode(_component_v_row, {
                justify: "center"
              }, {
                default: _withCtx(() => [!reportState.openDrawer ? (_openBlock(), _createBlock(LlSecondaryButton, {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = _withModifiers($event => toggleDrawer(), ["stop"])),
                  class: "chevron-btn top-20 at-chevron-left-btn",
                  icon: "mdi-chevron-double-left",
                  variant: "text",
                  size: "small",
                  "aria-label": "Collapse report navigation"
                })) : _createCommentVNode("", true), reportState.openDrawer ? (_openBlock(), _createBlock(LlSecondaryButton, {
                  key: 1,
                  onClick: _cache[1] || (_cache[1] = _withModifiers($event => toggleDrawer(), ["stop"])),
                  class: "chevron-btn top-20 at-chevron-right-btn",
                  icon: "mdi-chevron-double-right",
                  variant: "text",
                  size: "small",
                  "aria-label": "Expand report navigation"
                })) : _createCommentVNode("", true)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_v_list, {
              nav: "",
              class: "nav-bar-list"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_v_list_item, {
                onClick: _cache[2] || (_cache[2] = $event => standardReport()),
                class: _normalizeClass([!reportState.openDrawer ? 'overflow-list-item' : 'hide-list', reportState.standardReport && !_unref(embeddedReportStore).highlightedDashboardId ? 'll-nav-current-y' : '']),
                "aria-current": reportState.standardReport && !_unref(embeddedReportStore).highlightedDashboardId ? 'page' : undefined
              }, {
                default: _withCtx(() => [_createElementVNode("span", _hoisted_2, [_createVNode(_component_v_list_item_title, {
                  class: "flex align-middle items-center at-standard-reports",
                  title: "Standard Reports"
                }, {
                  default: _withCtx(() => [_createVNode(_component_v_icon, {
                    class: "mr-2"
                  }, {
                    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode("mdi-chart-box-outline", -1)]))]),
                    _: 1
                  }), _cache[12] || (_cache[12] = _createElementVNode("span", {
                    class: "text-black text-lg font-bold"
                  }, " Standard Reports ", -1))]),
                  _: 1
                })])]),
                _: 1
              }, 8, ["class", "aria-current"]), _createVNode(_component_v_list_item, {
                class: _normalizeClass([!reportState.openDrawer ? 'overflow-list-item' : 'hide-list'])
              }, {
                default: _withCtx(() => [_createElementVNode("span", {
                  class: "w-full flex justify-between",
                  onClick: toggleAdvancedReports
                }, [_createVNode(_component_v_list_item_title, {
                  class: "cursor-pointer flex justify-center align-middle at-advanced-reports"
                }, {
                  default: _withCtx(() => [_createVNode(_component_v_icon, {
                    class: "mr-2"
                  }, {
                    default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode("mdi-chart-line", -1)]))]),
                    _: 1
                  }), _createElementVNode("span", _hoisted_3, [_cache[14] || (_cache[14] = _createElementVNode("span", {
                    class: "text-black text-lg font-bold"
                  }, "Advanced Reports", -1)), reportState.me.features?.upgradeShortTermReport ? (_openBlock(), _createBlock(_component_v_badge, {
                    key: 0,
                    color: reportState.proBadgeColor,
                    content: "Pro",
                    inline: "",
                    class: "custom-badge"
                  }, null, 8, ["color"])) : _createCommentVNode("", true), !reportState.me.features?.upgradeShortTermReport ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_4, " BETA ", 512)), [[_vShow, reportState.showBetaTag]]) : _createCommentVNode("", true)])]),
                  _: 1
                }), _createElementVNode("span", _hoisted_5, [_withDirectives(_createVNode(ArrowDownSvg, null, null, 512), [[_vShow, !reportState.advancedReports]]), _withDirectives(_createVNode(ArrowUpSvg, null, null, 512), [[_vShow, reportState.advancedReports]])])]), reportState.loadingDashboardTitle && reportState.advancedReports ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_v_progress_circular, {
                  size: 40,
                  width: 3,
                  "bg-color": '#E0FFE0',
                  indeterminate: "",
                  color: "success"
                }), _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)), _cache[16] || (_cache[16] = _createElementVNode("h2", null, "Loading Advanced Reports", -1)), _cache[17] || (_cache[17] = _createElementVNode("p", null, "Just a moment...", -1))])) : (_openBlock(), _createElementBlock("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reportState.leftNavBarOptions, (leftNavbarReportOption, ids) => {
                  return _withDirectives((_openBlock(), _createBlock(_component_v_list_item, {
                    key: ids,
                    onClick: _cache[3] || (_cache[3] = $event => reportState.advancedReports = !reportState.advancedReports)
                  }, {
                    default: _withCtx(() => [_createVNode(_component_v_list_item_content, _mergeProps({
                      ref_for: true
                    }, props, {
                      class: [!reportState.openDrawer ? 'overflow-list-item' : '']
                    }), {
                      default: _withCtx(() => [_createElementVNode("div", {
                        class: _normalizeClass([[leftNavbarReportOption.isEmbeddedCustomReport ? 'custom-list-height' : ''], "rounded-md"])
                      }, [_createElementVNode("div", _hoisted_8, [_createVNode(LeftNavBar, {
                        alerts: __props.alerts,
                        tracking: __props.tracking,
                        userService: __props.userService,
                        reportState: reportState,
                        leftNavbarReportOption: leftNavbarReportOption,
                        embeddedReportKeys: reportState.embeddedReportKeys,
                        onEditDashboard: editDashboard,
                        onDeleteDashboard: deleteDashboard,
                        onOpenDashboard: openDashboard,
                        onCopyDashboard: copyDashboard
                      }, null, 8, ["alerts", "tracking", "userService", "reportState", "leftNavbarReportOption", "embeddedReportKeys"])])], 2)]),
                      _: 2
                    }, 1040, ["class"])]),
                    _: 2
                  }, 1024)), [[_vShow, reportState.advancedReports && leftNavbarReportOption.showReportList && leftNavbarReportOption.isEmbeddedAdvancedReport]]);
                }), 128))]))]),
                _: 1
              }, 8, ["class"]), reportState.showCustomMetabaseReportsSection ? (_openBlock(), _createBlock(_component_v_list_item, {
                key: 0,
                class: _normalizeClass([!reportState.openDrawer ? 'overflow-list-item' : 'hide-list'])
              }, {
                default: _withCtx(() => [_createElementVNode("span", {
                  class: "w-full flex justify-between",
                  onClick: toggleCustomMetabaseReports
                }, [_createVNode(_component_v_list_item_title, {
                  class: "cursor-pointer flex justify-center align-middle at-custom-metabase-reports"
                }, {
                  default: _withCtx(() => [_createVNode(_component_v_icon, {
                    class: "mr-2"
                  }, {
                    default: _withCtx(() => [...(_cache[18] || (_cache[18] = [_createTextVNode("mdi-view-dashboard-outline", -1)]))]),
                    _: 1
                  }), _cache[19] || (_cache[19] = _createElementVNode("span", {
                    class: "text-base font-medium"
                  }, [_createElementVNode("span", {
                    class: "text-black text-lg font-bold"
                  }, "Custom Reports")], -1)), _createVNode(_component_v_badge, {
                    color: reportState.betaBadgeColor,
                    content: "New",
                    inline: "",
                    class: "custom-badge"
                  }, null, 8, ["color"])]),
                  _: 1
                }), _createElementVNode("span", _hoisted_9, [_withDirectives(_createVNode(ArrowDownSvg, null, null, 512), [[_vShow, !reportState.customMetabaseReports]]), _withDirectives(_createVNode(ArrowUpSvg, null, null, 512), [[_vShow, reportState.customMetabaseReports]])])]), _createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reportState.leftNavBarOptions, (leftNavbarReportOption, ids) => {
                  return _withDirectives((_openBlock(), _createBlock(_component_v_list_item, {
                    key: ids,
                    onClick: _cache[4] || (_cache[4] = $event => reportState.customMetabaseReports = !reportState.customMetabaseReports)
                  }, {
                    default: _withCtx(() => [_createVNode(_component_v_list_item_content, _mergeProps({
                      ref_for: true
                    }, props, {
                      class: [!reportState.openDrawer ? 'overflow-list-item' : '']
                    }), {
                      default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(LeftNavBar, {
                        alerts: __props.alerts,
                        tracking: __props.tracking,
                        userService: __props.userService,
                        reportState: reportState,
                        leftNavbarReportOption: leftNavbarReportOption,
                        embeddedReportKeys: reportState.embeddedReportKeys,
                        onEditDashboard: editDashboard,
                        onDeleteDashboard: deleteDashboard,
                        onOpenDashboard: openDashboard,
                        onCopyDashboard: copyDashboard
                      }, null, 8, ["alerts", "tracking", "userService", "reportState", "leftNavbarReportOption", "embeddedReportKeys"])])])]),
                      _: 2
                    }, 1040, ["class"])]),
                    _: 2
                  }, 1024)), [[_vShow, reportState.customMetabaseReports && leftNavbarReportOption.showReportList && leftNavbarReportOption.isEmbeddedMetabaseCustomReport]]);
                }), 128))])]),
                _: 1
              }, 8, ["class"])) : _createCommentVNode("", true)])]),
              _: 1
            }), !(reportState.me.features?.luzmoDead === true) && (_unref(embeddedReportStore).keys?.canUseEditor || reportState.me.features?.luzmoTransition) ? (_openBlock(), _createBlock(_component_v_list, {
              key: 0,
              nav: "",
              class: "nav-bar-list"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_unref(embeddedReportStore).keys ? (_openBlock(), _createBlock(_component_v_alert, {
                key: 0,
                type: "warning",
                variant: "tonal",
                density: "compact",
                class: "text-sm flex-1"
              }, {
                text: _withCtx(() => [_unref(embeddedReportStore).keys?.canUseEditor ? (_openBlock(), _createElementBlock("p", _hoisted_13, " The \"My Custom Reports\" and \"Shared Reports\" sections will not be available after 8/1/2026 as we are transitioning to a new reporting architecture. You should have been notified via email regarding a plan for which reports are migrated. Migrated reports will appear in the \"Custom Reports\" section above. ")) : (_openBlock(), _createElementBlock("p", _hoisted_14, " The \"Shared Reports\" section will not be available after 8/1/2026 as we are transitioning to a new reporting architecture. We are working with your firm administrator on migrating reports and they will appear in the \"Custom Reports\" section above. "))]),
                _: 1
              })) : _createCommentVNode("", true), _withDirectives(_createVNode(_component_v_list_item, {
                class: _normalizeClass([!reportState.openDrawer ? 'overflow-list-item' : 'hide-list'])
              }, {
                default: _withCtx(() => [_createElementVNode("span", {
                  class: "w-full flex justify-between",
                  onClick: _cache[5] || (_cache[5] = $event => reportState.customReports = !reportState.customReports)
                }, [_createVNode(_component_v_list_item_title, {
                  class: "cursor-pointer flex justify-center align-middle at-custom-reports"
                }, {
                  default: _withCtx(() => [_createVNode(_component_v_icon, {
                    class: "mr-2"
                  }, {
                    default: _withCtx(() => [...(_cache[20] || (_cache[20] = [_createTextVNode("mdi-chart-timeline-variant-shimmer", -1)]))]),
                    _: 1
                  }), _cache[21] || (_cache[21] = _createElementVNode("span", {
                    class: "text-base font-medium"
                  }, [_createElementVNode("span", {
                    class: "text-black text-lg font-bold"
                  }, "My Custom Reports")], -1))]),
                  _: 1
                }), _createElementVNode("span", _hoisted_15, [_withDirectives(_createVNode(ArrowDownSvg, null, null, 512), [[_vShow, !reportState.customReports]]), _withDirectives(_createVNode(ArrowUpSvg, null, null, 512), [[_vShow, reportState.customReports]])])]), reportState.loadingDashboardTitle && reportState.customReports ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createVNode(_component_v_progress_circular, {
                  size: 40,
                  width: 3,
                  "bg-color": '#E0FFE0',
                  indeterminate: "",
                  color: "success"
                }), _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1)), _cache[23] || (_cache[23] = _createElementVNode("h2", null, "Loading Custom Reports", -1)), _cache[24] || (_cache[24] = _createElementVNode("p", null, "Just a moment...", -1))])) : (_openBlock(), _createElementBlock("div", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reportState.leftNavBarOptions, (leftNavbarReportOption, ids) => {
                  return _withDirectives((_openBlock(), _createBlock(_component_v_list_item, {
                    key: ids,
                    onClick: _cache[6] || (_cache[6] = $event => reportState.customReports = !reportState.customReports)
                  }, {
                    default: _withCtx(() => [_createVNode(_component_v_list_item_content, _mergeProps({
                      ref_for: true
                    }, props, {
                      class: [!reportState.openDrawer ? 'overflow-list-item' : 'hide-list']
                    }), {
                      default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_18, null, 512), [[_vShow, reportState.customReports]]), _createElementVNode("div", _hoisted_19, [_createVNode(LeftNavBar, {
                        alerts: __props.alerts,
                        tracking: __props.tracking,
                        userService: __props.userService,
                        leftNavbarReportOption: leftNavbarReportOption,
                        embeddedReportKeys: reportState.embeddedReportKeys,
                        reportState: reportState,
                        onEditDashboard: editDashboard,
                        onDeleteDashboard: deleteDashboard,
                        onOpenDashboard: openDashboard
                      }, null, 8, ["alerts", "tracking", "userService", "leftNavbarReportOption", "embeddedReportKeys", "reportState"])])]),
                      _: 2
                    }, 1040, ["class"])]),
                    _: 2
                  }, 1024)), [[_vShow, reportState.customReports && leftNavbarReportOption.showReportList && leftNavbarReportOption.isEmbeddedCustomReport]]);
                }), 128))]))]),
                _: 1
              }, 8, ["class"]), [[_vShow, _unref(embeddedReportStore).keys?.canUseEditor]]), _createVNode(_component_v_list_item, {
                class: _normalizeClass([!reportState.openDrawer ? 'overflow-list-item' : 'hide-list'])
              }, {
                default: _withCtx(() => [_createElementVNode("span", {
                  class: "flex justify-between",
                  onClick: _cache[7] || (_cache[7] = $event => reportState.sharedReports = !reportState.sharedReports)
                }, [_createVNode(_component_v_list_item_title, {
                  class: "cursor-pointer flex justify-center align-middle items-center at-shared-reports"
                }, {
                  default: _withCtx(() => [_createVNode(_component_v_icon, {
                    class: "mr-2"
                  }, {
                    default: _withCtx(() => [...(_cache[25] || (_cache[25] = [_createTextVNode("mdi-share", -1)]))]),
                    _: 1
                  }), _cache[26] || (_cache[26] = _createElementVNode("span", {
                    class: "text-base font-medium"
                  }, [_createElementVNode("span", {
                    class: "text-black text-lg font-bold"
                  }, " Shared Reports")], -1))]),
                  _: 1
                }), _createElementVNode("span", _hoisted_20, [_withDirectives(_createVNode(ArrowDownSvg, null, null, 512), [[_vShow, !reportState.sharedReports]]), _withDirectives(_createVNode(ArrowUpSvg, null, null, 512), [[_vShow, reportState.sharedReports]])])]), reportState.loadingDashboardTitle && reportState.sharedReports ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createVNode(_component_v_progress_circular, {
                  size: 40,
                  width: 3,
                  "bg-color": '#E0FFE0',
                  indeterminate: "",
                  color: "success"
                }), _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1)), _cache[28] || (_cache[28] = _createElementVNode("h2", null, "Loading Shared Reports", -1)), _cache[29] || (_cache[29] = _createElementVNode("p", null, "Just a moment...", -1))])) : (_openBlock(), _createElementBlock("div", _hoisted_22, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reportState.leftNavBarOptions, (leftNavbarReportOption, ids) => {
                  return _withDirectives((_openBlock(), _createBlock(_component_v_list_item, {
                    key: ids,
                    onClick: _cache[8] || (_cache[8] = $event => reportState.sharedReports = !reportState.sharedReports)
                  }, {
                    default: _withCtx(() => [_createVNode(_component_v_list_item_content, _mergeProps({
                      ref_for: true
                    }, props), {
                      default: _withCtx(() => [_withDirectives(_createElementVNode("div", {
                        class: _normalizeClass([[leftNavbarReportOption.isEmbeddedSharedReport ? 'custom-list-height' : ''], "rounded-md"])
                      }, [_unref(embeddedReportStore).getSharedReportOptions().length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createVNode(LeftNavBar, {
                        alerts: __props.alerts,
                        tracking: __props.tracking,
                        userService: __props.userService,
                        leftNavbarReportOption: leftNavbarReportOption,
                        embeddedReportKeys: reportState.embeddedReportKeys,
                        onEditDashboard: editDashboard,
                        onDeleteDashboard: deleteDashboard,
                        onOpenDashboard: openDashboard,
                        onCopyDashboard: copyDashboard
                      }, null, 8, ["alerts", "tracking", "userService", "leftNavbarReportOption", "embeddedReportKeys"])])) : (_openBlock(), _createElementBlock("div", _hoisted_24, [_createVNode(_component_v_card_text, {
                        class: "notes"
                      }, {
                        default: _withCtx(() => [...(_cache[30] || (_cache[30] = [_createTextVNode(" Currently, you do not have any reports shared with you. ", -1)]))]),
                        _: 1
                      })]))], 2), [[_vShow, reportState.sharedReports]])]),
                      _: 2
                    }, 1040)]),
                    _: 2
                  }, 1024)), [[_vShow, reportState.sharedReports && leftNavbarReportOption.showReportList && leftNavbarReportOption.isEmbeddedSharedReport]]);
                }), 128))]))]),
                _: 1
              }, 8, ["class"])])]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          }, 8, ["modelValue", "rail", "class"]), _createVNode(_component_v_main, {
            class: "overflow-y-auto outer-div at-main"
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              ref_key: "insightHome",
              ref: insightHome,
              class: _normalizeClass({
                'insights-home': !reportState.standardReport && reportState.embeddedReport
              })
            }, [_withDirectives(_createVNode(InsightsHome, {
              reportState: reportState,
              routeService: _unref(routeService),
              alerts: __props.alerts,
              tracking: __props.tracking
            }, null, 8, ["reportState", "routeService", "alerts", "tracking"]), [[_vShow, reportState.embeddedReport && !reportState.standardReport]])], 2), _createElementVNode("div", {
              ref_key: "navStandardDashboard",
              ref: navStandardDashboard
            }, [reportState.standardReport && !reportState.embeddedReport ? (_openBlock(), _createBlock(NavStandardDashboard, {
              key: 0,
              reportState: reportState,
              state: __props.state,
              stateParams: __props.stateParams,
              routeService: _unref(routeService),
              userService: __props.userService
            }, null, 8, ["reportState", "state", "stateParams", "routeService", "userService"])) : _createCommentVNode("", true)], 512), reportState.me.features?.upgradeShortTermReport && reportState.openSplashPage && reportState.showSplashPage ? (_openBlock(), _createBlock(SplashPage, {
              key: 0,
              reportState: reportState,
              userService: __props.userService,
              tracking: __props.tracking,
              alerts: __props.alerts,
              state: __props.state,
              routeService: _unref(routeService),
              onCloseSplashPage: closeSplashPage
            }, null, 8, ["reportState", "userService", "tracking", "alerts", "state", "routeService"])) : _createCommentVNode("", true)]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }));
    };
  }
};